import "./honeybadger_init"
import "@hotwired/turbo-rails"
import "./controllers"
import { installGlobalErrorHandlers, purgeOldLogs, logEvent } from "./field_logger"
import { warmVisitedPage } from "./field_offline_resources"
import { installFieldNavigation } from "./lib/field_navigation"
import { logAppVersionChange, runningAppVersion } from "./field_app_version"
import { initForegroundTime } from "./field_foreground_time"
installGlobalErrorHandlers()
purgeOldLogs()
logAppVersionChange()
// Card #3864 -- field screen changes on a bad or missing network: offline
// short-circuit, a Turbo visit timeout, and slow-screen timing in the app log.
installFieldNavigation()

// Card #4838 -- how long the app is actually on screen, and in which area,
// for battery-drain analysis. Self-contained: owns its own visibility/
// lifecycle listeners from here on.
initForegroundTime()

// Battery monitoring is on by default and can be switched off in Settings >
// Diagnostics. The field-battery Stimulus controller, mounted on the field
// layout body, starts and stops it (card #4143).

// Log service worker lifecycle events for diagnostics
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.addEventListener("message", (event) => {
    if (event.data?.type === "SW_INSTALLED") {
      logEvent("sw", "Service worker installed", {
        cache: event.data.cache, pages: event.data.pages, complete: event.data.complete
      }).catch(() => {})
    } else if (event.data?.type === "SW_UPDATED") {
      logEvent("sw", "Service worker activated", { appVersion: runningAppVersion() }).catch(() => {})
    } else if (event.data?.type === "QUEUE_CHANGED") {
      // Card #3863 -- a background sync pass in the worker touched the queue.
      // Its writes don't fire this page's Dexie hooks, so re-announce them.
      window.dispatchEvent(new CustomEvent("field:queue-changed", {
        detail: { source: "service-worker", successCount: Number(event.data.successCount) || 0 }
      }))
    }
  })
}

import * as Trix from "trix"
import "@rails/actiontext"
import "@37signals/lexxy"
import "@rails/activestorage"

import * as ActiveStorage from "@rails/activestorage"
ActiveStorage.start()

import Rails from "@rails/ujs"
Rails.start()

// Card #3827 -- cache field pages reached by a Turbo visit (a fetch, which the
// service worker's navigate route never caches). The first turbo:load is the
// full page load itself, which that route already cached, so it's skipped.
// warmVisitedPage owns the allow-list, online/Degraded checks and debounce.
let initialTurboLoad = true
document.addEventListener("turbo:load", () => {
  if (initialTurboLoad) {
    initialTurboLoad = false
    return
  }
  warmVisitedPage(window.location.pathname)
})

// Put this somewhere in /app/javascript
document.addEventListener("turbo:before-fetch-request", (event) => {
  event.detail.fetchOptions.headers["X-Turbo-Nonce"] =
    document.querySelector("meta[name='csp-nonce']")?.content
})

document.addEventListener("turbo:before-cache", () => {
  document.querySelectorAll("script[nonce]").forEach((element) => {
    element.setAttribute("nonce", element.nonce);
  })

  // Close any open dialogs before caching to prevent backdrop flash on restore
  document.querySelectorAll("dialog[open]").forEach((dialog) => {
    dialog.close()
  })
})

function maybeRestoreModal() {
  const responseId = localStorage.getItem("openModalResponseId");

  const onRelevantPage = window.location.pathname.startsWith("/responses") ||
                         window.location.pathname.startsWith("/images");

  if (responseId && onRelevantPage) {
    const viewLink = document.querySelector(`[data-response-id='${responseId}']`);
    if (viewLink) viewLink.click();
  } else {
    // Clear it either way
    localStorage.removeItem("openModalResponseId");
  }

}

// Run on page load and before Turbo visit
document.addEventListener("DOMContentLoaded", maybeRestoreModal);
document.addEventListener("turbo:before-visit", maybeRestoreModal);

// Limit date/datetime input year fields to 4 digits (prevents 6-digit years)
function capDateInputs() {
  document.querySelectorAll('input[type="date"]:not([max])').forEach(input => {
    input.max = "9999-12-31"
  })
  document.querySelectorAll('input[type="datetime-local"]:not([max])').forEach(input => {
    input.max = "9999-12-31T23:59"
  })
}
document.addEventListener("DOMContentLoaded", capDateInputs)
document.addEventListener("turbo:load", capDateInputs)
